import * as React from "react";

const NullIcon = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M13 3H3V13H13V3ZM12 4.70711L4.70711 12H6.29289L12 6.29289V4.70711ZM12 7.70711L7.70711 12H9.29289L12 9.29289V7.70711ZM12 10.7071L10.7071 12H12V10.7071ZM4 11.2929L11.2929 4H9.70711L4 9.70711V11.2929ZM4 8.29289L8.29289 4H6.70711L4 6.70711V8.29289ZM4 5.29289L5.29289 4H4V5.29289Z"
  />
);

const ChevronSouth = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M1.64648 5.35359L2.35359 4.64648L8.00004 10.2929L13.6465 4.64648L14.3536 5.35359L8.00004 11.7071L1.64648 5.35359Z"
  />
);

const ChevronWest = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M10.6464 1.64648L11.3535 2.35359L5.70707 8.00004L11.3535 13.6465L10.6464 14.3536L4.29286 8.00004L10.6464 1.64648Z"
  />
);

const ChevronEast = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M5.35359 14.3535L4.64648 13.6464L10.2929 7.99996L4.64648 2.35352L5.35359 1.64641L11.7071 7.99996L5.35359 14.3535Z"
  />
);

const ChevronNorth = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M14.3535 10.6464L13.6464 11.3535L7.99996 5.70707L2.35352 11.3535L1.64641 10.6464L7.99996 4.29286L14.3535 10.6464Z"
  />
);

const ArrowRefresh = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M7.9999 2.8999C5.18325 2.8999 2.8999 5.18325 2.8999 7.9999H1.8999C1.8999 4.63096 4.63097 1.8999 7.9999 1.8999C9.67778 1.8999 11.1975 2.57776 12.2999 3.67327V1.9999H13.2999V5.2999L9.9999 5.2999V4.2999L11.5099 4.2999C10.5952 3.43173 9.35976 2.8999 7.9999 2.8999ZM7.9999 13.0999C10.8166 13.0999 13.0999 10.8166 13.0999 7.9999H14.0999C14.0999 11.3688 11.3688 14.0999 7.9999 14.0999C6.32203 14.0999 4.80225 13.422 3.6999 12.3265V13.9999H2.6999V10.6999H5.9999V11.6999H4.48986C5.4046 12.5681 6.64004 13.0999 7.9999 13.0999Z"
  />
);

const ArrowExpand = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M10.2929 5H8V4H12V8H11V5.70711L5.70711 11H8V12H4V8H5V10.2929L10.2929 5Z"
  />
);

const ArrowExternal = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M14 1H9V2H13.293L8.14648 7.14648L8.85359 7.85359L14 2.70718V7H15V2V1H14ZM7 3H2V14H13V9H12V13H3V4H7V3Z"
  />
);

const ArrowEast = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M11.0355 7.5L7.64641 4.11092L8.35352 3.40381L12.9497 8L8.35352 12.5962L7.64641 11.8891L11.0355 8.5L3.75732 8.5L3.75732 7.5H11.0355Z"
  />
);

const ArrowSouth = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M8.5 11.0355L11.8891 7.64641L12.5962 8.35352L8 12.9497L3.4038 8.35352L4.11091 7.64641L7.5 11.0355L7.5 3.75732L8.5 3.75732V11.0355Z"
  />
);

const ArrowWest = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M4.9645 8.5L8.35359 11.8891L7.64648 12.5962L3.05029 8L7.64648 3.4038L8.35359 4.11091L4.9645 7.5L12.2427 7.5L12.2427 8.5L4.9645 8.5Z"
  />
);

const ArrowNorth = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M7.5 4.96438L4.11092 8.35347L3.40381 7.64636L8 3.05017L12.5962 7.64636L11.8891 8.35347L8.5 4.96438L8.5 12.2426L7.5 12.2426V4.96438Z"
  />
);

const ArrowNorthEast = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M10.2963 5H5.00346V4L12.0035 4V11H11.0035V5.70711L4.85701 11.8536L4.1499 11.1464L10.2963 5Z"
  />
);

const ArrowSouthEast = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M11 10.2965L11 5.00358L12 5.00358L12 12.0036L5 12.0036L5 11.0036L10.2929 11.0036L4.14645 4.85713L4.85355 4.15002L11 10.2965Z"
  />
);

const ArrowSouthWest = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M5.70707 11L11 11L11 12L3.99996 12L3.99996 5L4.99996 5L4.99996 10.2929L11.1464 4.14645L11.8535 4.85355L5.70707 11Z"
  />
);

const ArrowNorthWest = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M5 5.70707L5 11L4 11L4 3.99996L11 3.99996L11 4.99996L5.70711 4.99996L11.8536 11.1464L11.1464 11.8535L5 5.70707Z"
  />
);

const Locked = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M11 7H12C12.5523 7 13 7.44772 13 8V13C13 13.5523 12.5523 14 12 14H4C3.44772 14 3 13.5523 3 13V8C3 7.44772 3.44772 7 4 7H5V5C5 3.34315 6.34315 2 8 2C9.65685 2 11 3.34315 11 5V7ZM10 7V5C10 3.89543 9.10457 3 8 3C6.89543 3 6 3.89543 6 5V7H10ZM6 8H12V13H4V8H5H6Z"
  />
);

const Unlocked = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M10 5C10 3.89543 9.10457 3 8 3C6.89543 3 6 3.89543 6 5V7H12C12.5523 7 13 7.44772 13 8V11V13C13 13.5523 12.5523 14 12 14H4C3.44772 14 3 13.5523 3 13V8C3 7.44772 3.44772 7 4 7H5V5C5 3.34315 6.34315 2 8 2C9.65685 2 11 3.34315 11 5H10ZM4 8H5H6H12V13H4V8Z"
  />
);

const Copy = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.4999 4.29885L10.813 1.5L4.50002 1.50011L4.5 4.00007L5.5 4.00006L5.50001 2.5001L10.3868 2.50001L12.4999 4.70116V11.5H10.9999V12.5H13.4999V4.29885Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.81311 3.5L11.5 6.29885V14.5H2.5L2.50009 3.50011L8.81311 3.5ZM3.50008 4.5001L3.50001 13.5H10.5V6.70116L8.3869 4.50001L3.50008 4.5001Z"
    />
  </>
);

const ChevronDouble = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M8.00004 1.79285L4.14648 5.6464L4.85359 6.35351L8.00004 3.20706L11.1465 6.35351L11.8536 5.6464L8.00004 1.79285ZM4.85367 9.64648L4.14656 10.3536L8.00011 14.2071L11.8537 10.3536L11.1466 9.64648L8.00011 12.7929L4.85367 9.64648Z"
  />
);

const ChevronDoubleSmall = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M8.00004 3.79285L5.14648 6.6464L5.85359 7.35351L8.00004 5.20706L10.1465 7.35351L10.8536 6.6464L8.00004 3.79285ZM5.85367 8.64648L5.14656 9.35358L8.00011 12.2071L10.8537 9.35358L10.1466 8.64648L8.00011 10.7929L5.85367 8.64648Z"
  />
);

const Plus = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M7.5 8.5V13.5H8.5V8.5H13.5V7.5H8.5V2.5H7.5V7.5H2.5V8.5H7.5Z"
  />
);

const Checkmark = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M12.3536 5.35359L6.50004 11.2071L3.64648 8.35359L4.35359 7.64648L6.50004 9.79293L11.6465 4.64648L12.3536 5.35359Z"
  />
);

const CheckmarkBold = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M12.5304 5.53039L6.50006 11.5607L3.46973 8.53039L4.53039 7.46973L6.50006 9.4394L11.4697 4.46973L12.5304 5.53039Z"
  />
);

const Minus = () => (
  <path fillRule="evenodd" clipRule="evenodd" d="M13.5 8.5H2.5V7.5H13.5V8.5Z" />
);

const X = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M7.29289 7.99995L3.75747 11.5354L4.46458 12.2425L8 8.70706L11.5355 12.2426L12.2426 11.5355L8.70711 7.99995L12.2428 4.46431L11.5356 3.7572L8 7.29285L4.46443 3.75728L3.75732 4.46438L7.29289 7.99995Z"
  />
);

const ExclaimationMark = () => (
  <path d="M8.58008 3.27273L8.49485 9.54545H7.50621L7.42099 3.27273H8.58008ZM8.00053 12.0682C7.79031 12.0682 7.60991 11.9929 7.45934 11.8423C7.30877 11.6918 7.23349 11.5114 7.23349 11.3011C7.23349 11.0909 7.30877 10.9105 7.45934 10.7599C7.60991 10.6094 7.79031 10.5341 8.00053 10.5341C8.21076 10.5341 8.39116 10.6094 8.54173 10.7599C8.69229 10.9105 8.76758 11.0909 8.76758 11.3011C8.76758 11.5114 8.69229 11.6918 8.54173 11.8423C8.39116 11.9929 8.21076 12.0682 8.00053 12.0682Z" />
);

const Bullet = () => <circle cx="8" cy="8" r="3" />;

const LargeBullet = () => <circle cx="8" cy="8" r="5" />;

const Circle = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11ZM8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12Z"
  />
);

const TriangleEast = () => <path d="M12 8L5 12L5 4L12 8Z" />;

const TriangleSouth = () => <path d="M8 12L4 5L12 5L8 12Z" />;

const TriangleWest = () => <path d="M4 8L11 12L11 4L4 8Z" />;

const TriangleNorth = () => <path d="M8 4L4 11L12 11L8 4Z" />;

const CreateGroup = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M3.5 8C3.5 5.51472 5.51472 3.5 8 3.5V2.5C4.96243 2.5 2.5 4.96243 2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8H12.5C12.5 10.4853 10.4853 12.5 8 12.5C5.51472 12.5 3.5 10.4853 3.5 8ZM10 3H11V5H13V6H11V8H10V6H8V5H10V3Z"
  />
);

const Blank = () => <path />;

const ExclaimationMarkBold = () => (
  <path d="M8.82872 3.27271L8.6881 9.43464H7.31594L7.17957 3.27271H8.82872ZM8.00202 12.0937C7.74349 12.0937 7.5219 12.0028 7.33725 11.821C7.15259 11.6363 7.06168 11.4148 7.06452 11.1562C7.06168 10.9005 7.15259 10.6818 7.33725 10.5C7.5219 10.3182 7.74349 10.2273 8.00202 10.2273C8.25486 10.2273 8.47361 10.3182 8.65827 10.5C8.84293 10.6818 8.93668 10.9005 8.93952 11.1562C8.93668 11.4148 8.84293 11.6363 8.65827 11.821C8.47361 12.0028 8.25486 12.0937 8.00202 12.0937Z" />
);

const Smiley = () => (
  <>
    <circle cx="5" cy="6" r="1" />
    <circle cx="11" cy="6" r="1" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.61157 9C4.0663 11.004 5.85848 12.5 8.00006 12.5C10.1417 12.5 11.9338 11.004 12.3886 9H11.3551C10.9248 10.4457 9.58557 11.5 8.00006 11.5C6.41455 11.5 5.07528 10.4457 4.645 9H3.61157Z"
    />
  </>
);

const XSmall = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M8.00004 7.29293L10.6465 4.64648L11.3536 5.35359L8.70714 8.00004L11.3536 10.6465L10.6465 11.3536L8.00004 8.70714L5.35359 11.3536L4.64648 10.6465L7.29293 8.00004L4.64648 5.35359L5.35359 4.64648L8.00004 7.29293Z"
  />
);

const PlusSmall = () => (
  <path d="M7.5 8.5L7.5 12H8.5V8.5H12V7.5H8.5V4H7.5L7.5 7.5H4V8.5H7.5Z" />
);

const Weather = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M5.98161 5.97489L5.38136 6.00275C4.05616 6.06424 3 7.15907 3 8.5C3 9.75859 3.931 10.8015 5.1416 10.9746L5.31895 11H11C12.1046 11 13 10.1046 13 9C13 8.12681 12.4398 7.38188 11.6563 7.10987L11.0494 6.8992L10.9887 6.25966C10.8684 4.9922 9.79947 4 8.5 4C7.50315 4 6.64056 4.58341 6.23878 5.43182L5.98161 5.97489ZM5 11.9646C3.30385 11.7219 2 10.2632 2 8.5C2 6.62231 3.47861 5.08997 5.335 5.00382C5.89595 3.81929 7.1023 3 8.5 3C10.3201 3 11.8156 4.38924 11.9842 6.16517C13.1576 6.57251 14 7.68788 14 9C14 10.6569 12.6569 12 11 12H5V11.9646Z"
  />
);

const Clock = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 13C10.7614 13 13 10.7614 13 8C13 5.23858 10.7614 3 8 3C5.23858 3 3 5.23858 3 8C3 10.7614 5.23858 13 8 13ZM8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 5H8.5V8.19098L10.2236 9.05279L9.77639 9.94721L7.5 8.80902V5Z"
    />
  </>
);

const Chat = () => (
  <path d="M10.8571 12.2918L11.014 11.817L10.7959 11.745L10.5991 11.8635L10.8571 12.2918ZM12.2857 10.8623L11.8645 10.5929L11.7358 10.7942L11.8115 11.0207L12.2857 10.8623ZM13 13L12.8431 13.4747C13.0228 13.5341 13.2206 13.487 13.3541 13.353C13.4877 13.219 13.5342 13.021 13.4742 12.8415L13 13ZM10.5991 11.8635C9.94405 12.2582 8.87909 12.5 8 12.5V13.5C9.00806 13.5 10.2645 13.2326 11.1152 12.7201L10.5991 11.8635ZM8 12.5C5.51471 12.5 3.5 10.4853 3.5 8.00004H2.5C2.5 11.0376 4.96244 13.5 8 13.5V12.5ZM3.5 8.00004C3.5 5.51475 5.51472 3.5 8 3.5V2.5C4.96242 2.5 2.5 4.96247 2.5 8.00004H3.5ZM8 3.5C10.4853 3.5 12.5 5.51475 12.5 8.00004H13.5C13.5 4.96247 11.0376 2.5 8 2.5V3.5ZM12.5 8.00004C12.5 8.93552 12.2914 9.92518 11.8645 10.5929L12.707 11.1316C13.2729 10.2465 13.5 9.046 13.5 8.00004H12.5ZM10.7002 12.7665L12.8431 13.4747L13.1569 12.5253L11.014 11.817L10.7002 12.7665ZM13.4742 12.8415L12.7599 10.7038L11.8115 11.0207L12.5258 13.1585L13.4742 12.8415Z" />
);

const Attachment = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.78361 2.70909C8.30172 2.19097 9.00444 1.8999 9.73716 1.8999C11.263 1.8999 12.4999 3.13682 12.4999 4.66264C12.4999 5.39537 12.2088 6.09808 11.6907 6.6162L7.08483 11.2221C6.77888 11.528 6.36394 11.6999 5.93127 11.6999C5.03029 11.6999 4.2999 10.9695 4.2999 10.0685C4.2999 9.63587 4.47178 9.22092 4.77772 8.91498L9.24635 4.44635L9.95345 5.15346L5.48483 9.62209C5.36642 9.74049 5.2999 9.90108 5.2999 10.0685C5.2999 10.4172 5.58258 10.6999 5.93127 10.6999C6.09872 10.6999 6.25931 10.6334 6.37772 10.515L10.9836 5.90909C11.3142 5.57851 11.4999 5.13015 11.4999 4.66264C11.4999 3.68911 10.7107 2.8999 9.73716 2.8999C9.26965 2.8999 8.82129 3.08562 8.49071 3.4162L3.74757 8.15934C3.20482 8.7021 2.8999 9.43822 2.8999 10.2058C2.8999 11.8042 4.19564 13.0999 5.79401 13.0999C6.56158 13.0999 7.29771 12.795 7.84046 12.2522L12.4463 7.64635L13.1535 8.35346L8.54757 12.9593C7.81728 13.6896 6.8268 14.0999 5.79401 14.0999C3.64336 14.0999 1.8999 12.3564 1.8999 10.2058C1.8999 9.17301 2.31017 8.18252 3.04046 7.45224L7.78361 2.70909Z"
    />
  </>
);

const Publish = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M3.1001 1.8999H11.6001C12.7599 1.8999 13.7001 2.8401 13.7001 3.9999V11.1999C13.7001 12.3597 12.7599 13.2999 11.6001 13.2999H6.5001V13.9999H5.5001V13.2999H3.1001V1.8999ZM6.5001 12.2999H11.6001C12.2076 12.2999 12.7001 11.8074 12.7001 11.1999V3.9999C12.7001 3.39239 12.2076 2.8999 11.6001 2.8999H6.5001V12.2999ZM5.5001 2.8999V12.2999H4.1001V2.8999H5.5001ZM11.2001 6.0999H8.0001V5.0999H11.2001V6.0999Z"
  />
);

const Groups = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M4.4 5.8C5.1732 5.8 5.8 5.1732 5.8 4.4C5.8 3.6268 5.1732 3 4.4 3C3.6268 3 3 3.6268 3 4.4C3 5.1732 3.6268 5.8 4.4 5.8ZM6.74784 4.9C6.55199 5.82422 5.82422 6.55199 4.9 6.74784V9.25216C5.82422 9.44801 6.55199 10.1758 6.74784 11.1H9.25216C9.44801 10.1758 10.1758 9.44801 11.1 9.25216V6.74784C10.1758 6.55199 9.44801 5.82422 9.25216 4.9H6.74784ZM9.25216 3.9C9.48219 2.8145 10.446 2 11.6 2C12.9255 2 14 3.07452 14 4.4C14 5.55402 13.1855 6.51781 12.1 6.74784V9.25216C13.1855 9.48219 14 10.446 14 11.6C14 12.9255 12.9255 14 11.6 14C10.446 14 9.48219 13.1855 9.25216 12.1H6.74784C6.51781 13.1855 5.55402 14 4.4 14C3.07452 14 2 12.9255 2 11.6C2 10.446 2.8145 9.48219 3.9 9.25216V6.74784C2.8145 6.51781 2 5.55402 2 4.4C2 3.07452 3.07452 2 4.4 2C5.55402 2 6.51781 2.8145 6.74784 3.9H9.25216ZM11.6 5.8C12.3732 5.8 13 5.1732 13 4.4C13 3.6268 12.3732 3 11.6 3C10.8268 3 10.2 3.6268 10.2 4.4C10.2 5.1732 10.8268 5.8 11.6 5.8ZM13 11.6C13 12.3732 12.3732 13 11.6 13C10.8268 13 10.2 12.3732 10.2 11.6C10.2 10.8268 10.8268 10.2 11.6 10.2C12.3732 10.2 13 10.8268 13 11.6ZM4.4 13C5.1732 13 5.8 12.3732 5.8 11.6C5.8 10.8268 5.1732 10.2 4.4 10.2C3.6268 10.2 3 10.8268 3 11.6C3 12.3732 3.6268 13 4.4 13Z"
  />
);

const Gear = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M6.16271 3.76511L4.90354 2.81793C4.54968 3.02032 4.21841 3.25634 3.91432 3.5215L4.43733 4.95812C4.55802 5.28965 4.30665 5.63852 3.95397 5.62899L2.37764 5.58635C2.21487 5.94798 2.08756 6.3283 2 6.72309L3.28659 7.58453C3.58236 7.78256 3.58236 8.21744 3.28659 8.41547L2 9.27691C2.08756 9.6717 2.21487 10.052 2.37764 10.4136L3.95397 10.371C4.30665 10.3615 4.55802 10.7104 4.43733 11.0419L3.91432 12.4785C4.21841 12.7437 4.54968 12.9797 4.90354 13.1821L6.16271 12.2349C6.44057 12.0259 6.84165 12.1573 6.942 12.4902L7.38826 13.9706C7.58947 13.99 7.79355 14 8 14C8.20645 14 8.41053 13.99 8.61174 13.9706L9.058 12.4902C9.15835 12.1573 9.55943 12.0259 9.8373 12.2349L11.0965 13.1821C11.4503 12.9797 11.7816 12.7437 12.0857 12.4785L11.5627 11.0419C11.442 10.7104 11.6933 10.3615 12.046 10.371L13.6224 10.4136C13.7851 10.052 13.9124 9.6717 14 9.27691L12.7134 8.41547C12.4176 8.21744 12.4176 7.78256 12.7134 7.58453L14 6.72309C13.9124 6.3283 13.7851 5.94798 13.6224 5.58636L12.046 5.62899C11.6933 5.63852 11.442 5.28965 11.5627 4.95812L12.0857 3.5215C11.7816 3.25634 11.4503 3.02032 11.0965 2.81793L9.8373 3.76511C9.55943 3.97412 9.15835 3.84274 9.058 3.50984L8.61174 2.02941C8.41053 2.00996 8.20645 2 8 2C7.79355 2 7.58947 2.00996 7.38826 2.02941L6.942 3.50984C6.84165 3.84274 6.44057 3.97412 6.16271 3.76511ZM8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11Z"
  />
);

const LeapArrow = () => (
  <path d="M9.28539 3.65234L9.97303 3.00035L14 6.81854L9.97303 10.6367L9.28539 9.98473L12.1348 7.28729L4.97528 7.28728C3.87865 7.28728 2.98876 8.1353 2.98876 9.17933L2.98876 12L2 12L2 9.17933C2 7.61967 3.33483 6.34978 4.97528 6.34978L12.1348 6.34979L9.28539 3.65234Z" />
);

const Home = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M8 1.34155L14.5 6.91298L14.5001 14.5001H9.21429V11.4287C9.21429 10.758 8.67063 10.2144 8 10.2144C7.32937 10.2144 6.78572 10.758 6.78572 11.4287V14.5001H1.50006L1.5 6.91298L8 1.34155ZM2.5 7.37291L2.50005 13.5001H5.78572V11.4287C5.78572 10.2057 6.77709 9.21438 8 9.21438C9.22292 9.21438 10.2143 10.2057 10.2143 11.4287V13.5001H13.5001L13.5 7.37292L8 2.65863L2.5 7.37291Z"
  />
);

const Menu = () => (
  <>
    <path fillRule="evenodd" clipRule="evenodd" d="M14 8.5H2V7.5H14V8.5Z" />
    <path fillRule="evenodd" clipRule="evenodd" d="M2 2.5H14V3.5H2V2.5Z" />
    <path fillRule="evenodd" clipRule="evenodd" d="M14 13.5H2V12.5H14V13.5Z" />
  </>
);

const Node = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 8C3 10.7614 5.23858 13 8 13C10.7614 13 13 10.7614 13 8C13 5.23858 10.7614 3 8 3C5.23858 3 3 5.23858 3 8ZM8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2Z"
    />
    <path d="M9 8C9 8.55228 8.55228 9 8 9C7.44772 9 7 8.55228 7 8C7 7.44772 7.44772 7 8 7C8.55228 7 9 7.44772 9 8Z" />
  </>
);

const BootNode = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M8.5 1.5V5.73077H7.5V1.5H8.5ZM5.80029 6.5074L3.03106 3.73817L3.73817 3.03106L6.5074 5.80029L5.80029 6.5074ZM9.4926 5.80029L12.2618 3.03106L12.9689 3.73817L10.1997 6.5074L9.4926 5.80029ZM10.2699 7.49519L14.5006 7.50065L14.4994 8.50064L10.2686 8.49519L10.2699 7.49519ZM1.5 7.49583H5.73077V8.49583H1.5V7.49583ZM6.5074 10.1997L3.73817 12.9689L3.03106 12.2618L5.80029 9.4926L6.5074 10.1997ZM12.2618 12.9689L9.4926 10.1997L10.1997 9.4926L12.9689 12.2618L12.2618 12.9689ZM8.5 10.2692V14.5H7.5V10.2692H8.5Z"
  />
);

const Upload = () => (
  <>
    <path fillRule="evenodd" clipRule="evenodd" d="M2 8H3V12H13V8H14V13H2V8Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 2.9645L5.11092 5.35359L4.40381 4.64648L8 1.05029L11.5962 4.64648L10.8891 5.35359L8.5 2.9645L8.5 10.2427L7.5 10.2427V2.9645Z"
    />
  </>
);

const Download = () => (
  <>
    <path fillRule="evenodd" clipRule="evenodd" d="M2 8H3V12H13V8H14V13H2V8Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.5 8.82846L10.8891 6.43938L11.5962 7.14648L8 10.7427L4.4038 7.14648L5.11091 6.43938L7.5 8.82846L7.5 1.55029L8.5 1.55029V8.82846Z"
    />
  </>
);

const Dojo = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M14.4999 2.5L1.50008 2.50017L1.5 13.5H14.5L14.4999 2.5ZM1.50007 1.50017L14.4999 1.5C15.0522 1.49999 15.4999 1.9477 15.4999 2.49999L15.5 13.5C15.5 14.0523 15.0523 14.5 14.5 14.5H1.5C0.947713 14.5 0.499996 14.0523 0.5 13.5L0.500082 2.50016C0.500086 1.94789 0.947792 1.50018 1.50007 1.50017ZM8.02808 8.0001L3.74266 5.42885L4.25716 4.57136L9.97173 8.0001L4.25716 11.4288L3.74266 10.5714L8.02808 8.0001ZM12.4999 11.5001H8.99991V10.5001H12.4999V11.5001Z"
  />
);

const Adjust = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M4.1 8.35989L4.1 2H5.1L5.1 8.35989C6.0184 8.5842 6.7 9.4125 6.7 10.4C6.7 11.3875 6.0184 12.2158 5.1 12.4401V14H4.1V12.4401C3.1816 12.2158 2.5 11.3875 2.5 10.4C2.5 9.4125 3.1816 8.5842 4.1 8.35989ZM10.5 3.55989L10.5 2H11.5L11.5 3.55989C12.4184 3.7842 13.1 4.6125 13.1 5.6C13.1 6.5875 12.4184 7.4158 11.5 7.64011V14H10.5V7.64011C9.5816 7.4158 8.9 6.5875 8.9 5.6C8.9 4.6125 9.5816 3.7842 10.5 3.55989ZM11 4.5C10.3925 4.5 9.9 4.99249 9.9 5.6C9.9 6.20751 10.3925 6.7 11 6.7C11.6075 6.7 12.1 6.20751 12.1 5.6C12.1 4.99249 11.6075 4.5 11 4.5ZM4.6 9.3C3.99249 9.3 3.5 9.79249 3.5 10.4C3.5 11.0075 3.99249 11.5 4.6 11.5C5.20751 11.5 5.7 11.0075 5.7 10.4C5.7 9.79249 5.20751 9.3 4.6 9.3Z"
  />
);

const WestCarat = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M10.7764 4.55273L3.88199 7.99995L10.7764 11.4472L11.2236 10.5527L6.11806 7.99995L11.2236 5.44716L10.7764 4.55273Z"
  />
);

const EastCarat = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M5.22358 4.55273L12.118 7.99995L5.22358 11.4472L4.77637 10.5527L9.88194 7.99995L4.77637 5.44716L5.22358 4.55273Z"
  />
);

const Keyfile = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.05556 5.11111C4.91467 5.11111 5.61111 4.41467 5.61111 3.55556C5.61111 2.69645 4.91467 2 4.05556 2C3.19645 2 2.5 2.69645 2.5 3.55556C2.5 4.41467 3.19645 5.11111 4.05556 5.11111ZM4.05556 6.11111C5.46695 6.11111 6.61111 4.96695 6.61111 3.55556C6.61111 2.14416 5.46695 1 4.05556 1C2.64416 1 1.5 2.14416 1.5 3.55556C1.5 4.96695 2.64416 6.11111 4.05556 6.11111Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.55566 5.47217H4.55566V8.8055H6V9.8055H4.55566V10.7222H6.61122V11.7222H4.55566V12.4999H3.55566V5.47217Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.5 2.5H7V1.5H10.2071L13.5 4.79289V14.5H3.5V13.5H12.5V5.5H9.5V2.5ZM10.5 3.2071L11.7929 4.5H10.5V3.2071Z"
    />
  </>
);

const Image = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 3H3L3 13H13V3ZM3 2C2.44772 2 2 2.44772 2 3V13C2 13.5523 2.44772 14 3 14H13C13.5523 14 14 13.5523 14 13V3C14 2.44772 13.5523 2 13 2H3Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.99996 8.29297L6.99996 11.293L4.99996 9.29297L2.14641 12.1465L2.85352 12.8536L4.99996 10.7072L6.99996 12.7072L9.99996 9.70718L13.1464 12.8536L13.8535 12.1465L9.99996 8.29297Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 7C6.55228 7 7 6.55228 7 6C7 5.44772 6.55228 5 6 5C5.44772 5 5 5.44772 5 6C5 6.55228 5.44772 7 6 7ZM6 8C7.10457 8 8 7.10457 8 6C8 4.89543 7.10457 4 6 4C4.89543 4 4 4.89543 4 6C4 7.10457 4.89543 8 6 8Z"
    />
  </>
);

const Swap = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.91421 5.34608L7.27996 7.71182L6.57285 8.41893L3 4.84608L6.53553 1.31055L7.24264 2.01765L4.91421 4.34608H12.1924V5.34608H4.91421Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.7782 11.3463L8.41243 8.98054L9.11954 8.27344L12.6924 11.8463L9.15685 15.3818L8.44975 14.6747L10.7782 12.3463H3.5L3.5 11.3463H10.7782Z"
    />
  </>
);

const AddFile = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.2071 1.5L13.5 4.7929V14.5H2.5L2.50011 1.50013L10.2071 1.5ZM3.5001 2.50012L3.50001 13.5H12.5V5.5H9.5V2.50001L3.5001 2.50012ZM10.5 3.20711V4.5H11.7929L10.5 3.20711Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 8V6.5H8.5V8H10V9H8.5V10.5H7.5V9H6V8H7.5Z"
    />
  </>
);

const Collection = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 2H14V6H13V12.5C13 13.3284 12.3284 14 11.5 14H4.5C3.67157 14 3 13.3284 3 12.5V6H2V2ZM3 5H4V12.5C4 12.7761 4.22386 13 4.5 13H11.5C11.7761 13 12 12.7761 12 12.5V5H13V3H3V5ZM9.5 9H6.5V8H9.5V9Z"
    />
    <path fillRule="evenodd" clipRule="evenodd" d="M12.5 6H3.5V5H12.5V6Z" />
  </>
);

const Note = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M10.7113 1.5L13.5 4.36844V14.5H2.5L2.50011 1.50013L10.7113 1.5ZM3.5001 2.50012L3.50001 13.5H12.5V4.77443L10.2888 2.50001L3.5001 2.50012ZM5.00035 4.92599L9.33368 4.92891L9.33301 5.92891L4.99968 5.92599L5.00035 4.92599ZM5.00001 7.49608H11V8.49608H5.00001V7.49608ZM5.00057 10.0653L11.0006 10.072L10.9995 11.072L4.99945 11.0653L5.00057 10.0653Z"
  />
);

const Users = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 10H5C3.89543 10 3 10.8954 3 12V13H10V12C10 10.8954 9.10457 10 8 10ZM5 9C3.34315 9 2 10.3431 2 12V14H11V12C11 10.3431 9.65685 9 8 9H5Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 11.5C13 10.9477 12.5523 10.5 12 10.5V9.5C13.1046 9.5 14 10.3954 14 11.5V14H12V13H13V11.5Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 8C12.5523 8 13 7.55228 13 7C13 6.44772 12.5523 6 12 6C11.4477 6 11 6.44772 11 7C11 7.55228 11.4477 8 12 8ZM12 9C13.1046 9 14 8.10457 14 7C14 5.89543 13.1046 5 12 5C10.8954 5 10 5.89543 10 7C10 8.10457 10.8954 9 12 9Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5 7C7.88071 7 9 5.88071 9 4.5C9 3.11929 7.88071 2 6.5 2C5.11929 2 4 3.11929 4 4.5C4 5.88071 5.11929 7 6.5 7ZM6.5 8C8.433 8 10 6.433 10 4.5C10 2.567 8.433 1 6.5 1C4.567 1 3 2.567 3 4.5C3 6.433 4.567 8 6.5 8Z"
    />
  </>
);

const Server = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5 3H3.5C3.22386 3 3 3.22386 3 3.5V4.5C3 4.77614 3.22386 5 3.5 5H12.5C12.7761 5 13 4.77614 13 4.5V3.5C13 3.22386 12.7761 3 12.5 3ZM3.5 2C2.67157 2 2 2.67157 2 3.5V4.5C2 5.32843 2.67157 6 3.5 6H12.5C13.3284 6 14 5.32843 14 4.5V3.5C14 2.67157 13.3284 2 12.5 2H3.5Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5 6H3.5C3.22386 6 3 6.22386 3 6.5V8.5C3 8.77614 3.22386 9 3.5 9H12.5C12.7761 9 13 8.77614 13 8.5V6.5C13 6.22386 12.7761 6 12.5 6ZM3.5 5C2.67157 5 2 5.67157 2 6.5V8.5C2 9.32843 2.67157 10 3.5 10H12.5C13.3284 10 14 9.32843 14 8.5V6.5C14 5.67157 13.3284 5 12.5 5H3.5Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5 10H3.5C3.22386 10 3 10.2239 3 10.5V12.5C3 12.7761 3.22386 13 3.5 13H12.5C12.7761 13 13 12.7761 13 12.5V10.5C13 10.2239 12.7761 10 12.5 10ZM3.5 9C2.67157 9 2 9.67157 2 10.5V12.5C2 13.3284 2.67157 14 3.5 14H12.5C13.3284 14 14 13.3284 14 12.5V10.5C14 9.67157 13.3284 9 12.5 9H3.5Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 8H4V7H8V8ZM8 12H4V11H8V12Z"
    />
  </>
);

const Info = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 13C10.7614 13 13 10.7614 13 8C13 5.23858 10.7614 3 8 3C5.23858 3 3 5.23858 3 8C3 10.7614 5.23858 13 8 13ZM8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z"
    />
    <path d="M6.2334 7.032H9.0014V11H7.8254V7.952H6.2334V7.032ZM8.3614 6.448C8.13207 6.448 7.94273 6.384 7.7934 6.256C7.6494 6.128 7.5774 5.95467 7.5774 5.736C7.5774 5.51733 7.6494 5.34133 7.7934 5.208C7.94273 5.06933 8.13207 5 8.3614 5C8.59073 5 8.7774 5.06933 8.9214 5.208C9.07073 5.34133 9.1454 5.51733 9.1454 5.736C9.1454 5.95467 9.07073 6.128 8.9214 6.256C8.7774 6.384 8.59073 6.448 8.3614 6.448Z" />
  </>
);

const Dashboard = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 3H3L3 6H6V3ZM3 2C2.44772 2 2 2.44772 2 3V6C2 6.55228 2.44772 7 3 7H6C6.55228 7 7 6.55228 7 6V3C7 2.44772 6.55228 2 6 2H3Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 3H10L10 6H13V3ZM10 2C9.44772 2 9 2.44772 9 3V6C9 6.55228 9.44772 7 10 7H13C13.5523 7 14 6.55228 14 6V3C14 2.44772 13.5523 2 13 2H10Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 10H10L10 13H13V10ZM10 9C9.44772 9 9 9.44772 9 10V13C9 13.5523 9.44772 14 10 14H13C13.5523 14 14 13.5523 14 13V10C14 9.44772 13.5523 9 13 9H10Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 10H3L3 13H6V10ZM3 9C2.44772 9 2 9.44772 2 10V13C2 13.5523 2.44772 14 3 14H6C6.55228 14 7 13.5523 7 13V10C7 9.44772 6.55228 9 6 9H3Z"
    />
  </>
);

const Tutorial = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 6V8H8V6H9ZM9 11.5V15H8V11.5H9Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.79289 6L2.29289 3.5L4.79289 0.999996L13 0.999996L13 6L4.79289 6ZM12 5L12 2L5.20711 2L3.70711 3.5L5.20711 5L12 5Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 7L12.2071 7L14.7071 9.5L12.2071 12H4L4 7ZM5 8V11H11.7929L13.2929 9.5L11.7929 8L5 8Z"
    />
  </>
);

const Visible = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 8C0 8 2.95054 13 8 13C13.0495 13 16 8 16 8C16 8 13.0495 3 8 3C2.95054 3 0 8 0 8ZM1.2052 8C1.24559 8.05552 1.28944 8.11466 1.33669 8.17696C1.66482 8.60961 2.15124 9.18667 2.78078 9.76157C4.05021 10.9208 5.81985 12 8 12C10.1802 12 11.9498 10.9208 13.2192 9.76157C13.8488 9.18667 14.3352 8.60961 14.6633 8.17696C14.7106 8.11466 14.7544 8.05552 14.7948 8C14.7544 7.94448 14.7106 7.88534 14.6633 7.82304C14.3352 7.39039 13.8488 6.81333 13.2192 6.23843C11.9498 5.0792 10.1802 4 8 4C5.81985 4 4.05021 5.0792 2.78078 6.23843C2.15124 6.81333 1.66482 7.39039 1.33669 7.82304C1.28944 7.88534 1.24559 7.94448 1.2052 8ZM0.860361 7.49031C0.860155 7.48997 0.860124 7.48992 0.860269 7.49016L0.860361 7.49031Z"
    />
    <circle cx="8" cy="8" r="3" />
  </>
);

const Hidden = () => (
  <>
    <rect
      x="3.05029"
      y="0.635986"
      width="16"
      height="1"
      transform="rotate(45 3.05029 0.635986)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.26314e-07 7.00005C1.26314e-07 7.00005 2.95054 12 8 12C9.09567 12 10.0925 11.7646 10.9818 11.396L10.2072 10.6214C9.52841 10.8579 8.79124 11 8 11C5.81985 11 4.05021 9.92085 2.78078 8.76162C2.15124 8.18672 1.66482 7.60966 1.33669 7.17701C1.28944 7.11471 1.24559 7.05557 1.2052 7.00005C1.24559 6.94453 1.28944 6.88539 1.33669 6.82308C1.66482 6.39043 2.15124 5.81337 2.78078 5.23848C3.12449 4.9246 3.50488 4.61659 3.92015 4.33429L3.2017 3.61584C1.13496 5.07674 1.26314e-07 7.00005 1.26314e-07 7.00005ZM4.06753 3.06745C5.17694 2.44406 6.49527 2.00005 8 2.00005C13.0495 2.00005 16 7.00005 16 7.00005C16 7.00005 14.546 9.46399 11.9326 10.9326L11.1948 10.1947C11.9667 9.79532 12.6442 9.28668 13.2192 8.76162C13.8488 8.18672 14.3352 7.60966 14.6633 7.17701C14.7106 7.11471 14.7544 7.05557 14.7948 7.00005C14.7544 6.94453 14.7106 6.88539 14.6633 6.82308C14.3352 6.39043 13.8488 5.81337 13.2192 5.23848C11.9498 4.07924 10.1802 3.00005 8 3.00005C6.80739 3.00005 5.73763 3.32299 4.80539 3.80531L4.06753 3.06745ZM5.87874 4.87867C6.42163 4.33581 7.1716 4.00005 8 4.00005C9.65685 4.00005 11 5.34319 11 7.00005C11 7.82844 10.6642 8.57842 10.1214 9.12131L5.87874 4.87867ZM5.29241 5.70655L9.2935 9.70764C8.90184 9.89508 8.46318 10 8 10C6.34315 10 5 8.6569 5 7.00005C5 6.53687 5.10497 6.09821 5.29241 5.70655ZM0.860361 6.49036C0.860155 6.49002 0.860124 6.48996 0.860269 6.49021L0.860361 6.49036Z"
    />
  </>
);
const LogOut = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 2H9V3H4V12H9V13H3V2ZM10.3536 4.64645L13.2071 7.5L10.3536 10.3536L9.64645 9.64645L11.2929 8H6V7H11.2929L9.64645 5.35355L10.3536 4.64645Z"
    />
  </>
);

const LogIn = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 2H13V13H7V12H12V3H7V2ZM7.35355 4.64645L10.2071 7.5L7.35355 10.3536L6.64645 9.64645L8.29289 8H3V7H8.29289L6.64645 5.35355L7.35355 4.64645Z"
    />
  </>
);

const Search = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 7.5C11 9.433 9.433 11 7.5 11C5.567 11 4 9.433 4 7.5C4 5.567 5.567 4 7.5 4C9.433 4 11 5.567 11 7.5ZM10.3088 11.016C9.53901 11.6318 8.56251 12 7.5 12C5.01472 12 3 9.98528 3 7.5C3 5.01472 5.01472 3 7.5 3C9.98528 3 12 5.01472 12 7.5C12 8.56251 11.6318 9.53901 11.016 10.3088L13.3536 12.6464L12.6464 13.3536L10.3088 11.016Z"
    />
  </>
);

const Ellipsis = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.5 8C1.5 7.17157 2.17157 6.5 3 6.5C3.82843 6.5 4.5 7.17157 4.5 8C4.5 8.82843 3.82843 9.5 3 9.5C2.17157 9.5 1.5 8.82843 1.5 8ZM6.5 8C6.5 7.17157 7.17157 6.5 8 6.5C8.82843 6.5 9.5 7.17157 9.5 8C9.5 8.82843 8.82843 9.5 8 9.5C7.17157 9.5 6.5 8.82843 6.5 8ZM11.5 8C11.5 7.17157 12.1716 6.5 13 6.5C13.8284 6.5 14.5 7.17157 14.5 8C14.5 8.82843 13.8284 9.5 13 9.5C12.1716 9.5 11.5 8.82843 11.5 8Z"
    />
  </>
);

const Bitcoin = () => (
  <>
    <path d="M4.78285 11.3956L7.62037 11.9472C9.47626 12.3079 10.4191 11.5521 10.6486 10.371C10.8901 9.12866 10.1624 8.28684 9.45044 8.1007L9.46534 8.02401C10.176 7.97114 10.8606 7.64261 11.0574 6.63031C11.281 5.47996 10.696 4.39528 9.05481 4.07627L6.30933 3.5426L4.78285 11.3956ZM5.89778 10.7369L6.42847 8.00673L8.36105 8.38238C9.38869 8.58214 9.89872 9.39756 9.74369 10.1951C9.60952 10.8853 9.02672 11.3451 7.78435 11.1036L5.89778 10.7369ZM6.58946 7.17848L7.0963 4.57103L8.89084 4.91986C9.93382 5.12259 10.2866 5.7642 10.1525 6.45441C9.99147 7.28265 9.21225 7.6883 8.35333 7.52134L6.58946 7.17848Z" />
    <rect
      x="8.07886"
      y="2.86804"
      width="1"
      height="1"
      transform="rotate(11 8.07886 2.86804)"
    />
    <rect
      x="6.36157"
      y="11.7025"
      width="1"
      height="1"
      transform="rotate(11 6.36157 11.7025)"
    />
  </>
);

const Messages = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.2894 13.0305L13.603 12.6115C13.9633 12.1301 14.1763 11.5339 14.1763 10.885C14.1763 9.29167 12.8846 8 11.2913 8C9.69792 8 8.40625 9.29167 8.40625 10.885C8.40625 12.4784 9.69792 13.77 11.2913 13.77C11.7632 13.77 12.2059 13.6575 12.5968 13.4587L12.9696 13.2691L13.4189 13.4189L13.2894 13.0305ZM14.8419 14.5257C14.907 14.7211 14.7211 14.907 14.5257 14.8419L13.0501 14.35C12.522 14.6186 11.9243 14.77 11.2913 14.77C9.14563 14.77 7.40625 13.0307 7.40625 10.885C7.40625 8.73938 9.14563 7 11.2913 7C13.4369 7 15.1763 8.73938 15.1763 10.885C15.1763 11.7572 14.8889 12.5623 14.4036 13.2107L14.8419 14.5257Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.95245 9.37231L3.15819 9.75316L3.0213 10.1638L2.43629 11.9189L4.19133 11.3338L4.60198 11.197L4.98284 11.4027C5.68769 11.7835 6.49464 12 7.35515 12C7.4262 12 7.4969 11.9985 7.56722 11.9956C7.67016 12.3413 7.81992 12.6668 8.00914 12.9648C7.79434 12.9881 7.57614 13 7.35515 13C6.32463 13 5.35479 12.7402 4.50756 12.2825L2.041 13.1047L2.00153 13.1179L1.64572 13.2365L1.32949 13.3419C1.13405 13.407 0.948116 13.2211 1.01326 13.0257L1.11867 12.7094L1.23728 12.3536L1.25043 12.3141L2.07262 9.84759C1.61494 9.00035 1.35515 8.03052 1.35515 7C1.35515 3.68629 4.04144 1 7.35515 1C10.6689 1 13.3551 3.68629 13.3551 7C13.3551 7.1943 13.3459 7.38644 13.3279 7.576C13.0276 7.39079 12.7002 7.24531 12.353 7.14689C12.3544 7.0981 12.3551 7.04913 12.3551 7C12.3551 4.23858 10.1166 2 7.35515 2C4.59372 2 2.35515 4.23858 2.35515 7C2.35515 7.8605 2.57169 8.66745 2.95245 9.37231Z"
    />
  </>
);

const User = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 10H6C4.89543 10 4 10.8954 4 12V13H11V12C11 10.8954 10.1046 10 9 10ZM6 9C4.34315 9 3 10.3431 3 12V14H12V12C12 10.3431 10.6569 9 9 9H6Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 7C8.88071 7 10 5.88071 10 4.5C10 3.11929 8.88071 2 7.5 2C6.11929 2 5 3.11929 5 4.5C5 5.88071 6.11929 7 7.5 7ZM7.5 8C9.433 8 11 6.433 11 4.5C11 2.567 9.433 1 7.5 1C5.567 1 4 2.567 4 4.5C4 6.433 5.567 8 7.5 8Z"
    />
  </>
);

const Public = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5764 2.68741C3.64234 3.47359 1.90113 6.48944 2.68731 9.42351C2.95022 10.4047 3.46247 11.2525 4.13762 11.9169L4.34827 11.6979L3.39808 9.68284C3.30715 9.49001 3.28454 9.27199 3.33396 9.0646L3.80774 9.17752L3.33396 9.0646L3.65944 7.69896C3.6883 7.57787 3.74094 7.46373 3.81431 7.36317L4.58837 6.30227C4.69817 6.15179 4.85024 6.03736 5.02524 5.97353C5.20024 5.90971 5.39027 5.89938 5.57117 5.94384L5.45181 6.42939L5.57117 5.94384L6.06948 6.06634C6.28964 6.12046 6.48279 6.2524 6.61327 6.43781L6.68122 6.53436L6.79877 6.0837C6.83102 5.96008 6.88815 5.84434 6.96666 5.74356C7.04518 5.64278 7.14344 5.55908 7.25542 5.49759C7.3674 5.43609 7.49076 5.39809 7.61793 5.38592C7.7451 5.37374 7.87342 5.38764 7.99504 5.42676L8.88187 5.71206C8.82171 5.55491 8.80456 5.38357 8.83359 5.21601C8.87095 5.00038 8.98245 4.80457 9.14883 4.6624L10.1592 3.79901L9.66337 2.75688C8.69529 2.44873 7.63057 2.40495 6.5764 2.68741ZM11.1033 3.45909C11.1747 3.63339 11.1922 3.82557 11.1528 4.01057C11.1098 4.21257 11.0014 4.39476 10.8444 4.52893L9.83579 5.39075C9.91308 5.54423 9.94692 5.7163 9.93312 5.88823C9.91797 6.07707 9.84605 6.25691 9.72682 6.40413C9.60759 6.55136 9.44662 6.65907 9.26505 6.71314C9.08348 6.7672 8.8898 6.76509 8.70946 6.70707L7.75013 6.39845L7.61568 6.91387C7.57048 7.08718 7.47666 7.24394 7.34529 7.36567C7.21392 7.4874 7.05048 7.56903 6.87424 7.60092C6.69801 7.63282 6.51633 7.61365 6.35063 7.54568C6.18492 7.47771 6.04212 7.36378 5.93904 7.21732L5.80861 7.03198L5.37213 6.92469L4.62936 7.9427L4.31167 9.27566L5.27065 11.3094C5.35181 11.4815 5.37877 11.6742 5.34796 11.8619C5.31715 12.0497 5.23003 12.2237 5.09813 12.3608L4.91369 12.5526C6.18923 13.4165 7.81855 13.7426 9.42341 13.3126C10.5834 13.0018 11.557 12.3424 12.2616 11.4774L11.6505 11.1239L10.9846 11.3023C10.8543 11.3372 10.718 11.3436 10.585 11.3212C10.452 11.2987 10.3255 11.2478 10.2139 11.172C10.1023 11.0962 10.0084 10.9973 9.93846 10.8819C9.86855 10.7666 9.82431 10.6375 9.80875 10.5035L9.69093 9.4889C9.67381 9.3415 9.69187 9.19214 9.74362 9.05306C9.79538 8.91398 9.87936 8.78915 9.98867 8.6888L11.2279 7.55116C11.3683 7.42225 11.5446 7.33912 11.7334 7.31283C11.9222 7.28654 12.1146 7.31833 12.2849 7.40398L13.5013 8.0157C13.5023 7.54055 13.4414 7.05743 13.3125 6.5765C12.9583 5.25451 12.1514 4.17469 11.1033 3.45909ZM13.3939 9.08103L11.8732 8.31626L10.6878 9.40443L10.7939 10.3181L11.4161 10.1514C11.5354 10.1194 11.6598 10.1113 11.7822 10.1275C11.9046 10.1437 12.0227 10.1838 12.1295 10.2457L12.8215 10.6461C13.0889 10.1591 13.2831 9.63144 13.3939 9.08103ZM11.8356 8.29736L11.8358 8.29745L11.8356 8.29736ZM4.30256 9.25633C4.30258 9.25636 4.30259 9.25639 4.3026 9.25642L4.30256 9.25633ZM5.83063 7.0374C5.83067 7.03741 5.83072 7.03742 5.83076 7.03743L5.8453 6.97827L5.83076 7.03743L5.83063 7.0374ZM4.37721 11.6678L4.37736 11.6677L4.42127 11.7099L4.72313 12.0002L4.42127 11.7099L4.37736 11.6677C4.37731 11.6677 4.37726 11.6678 4.37721 11.6678ZM3.84133 12.9963C5.40903 14.2989 7.56367 14.8462 9.68223 14.2785C13.1498 13.3494 15.2075 9.78521 14.2784 6.31768C13.3493 2.85015 9.78511 0.792363 6.31758 1.72148C2.85005 2.65061 0.792265 6.2148 1.72139 9.68233C2.08284 11.0313 2.8431 12.1669 3.84133 12.9963Z"
    />
  </>
);

const Notifications = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 3H3L3 13H13V3ZM3 2C2.44772 2 2 2.44772 2 3V13C2 13.5523 2.44772 14 3 14H13C13.5523 14 14 13.5523 14 13V3C14 2.44772 13.5523 2 13 2H3Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 8.5H6.5V9C6.5 9.82843 7.17157 10.5 8 10.5C8.82843 10.5 9.5 9.82843 9.5 9V8.5H13V9.5H10.45C10.2184 10.6411 9.20948 11.5 8 11.5C6.79052 11.5 5.78164 10.6411 5.55001 9.5H3V8.5Z"
    />
  </>
);

const AddUser = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 10H5C3.89543 10 3 10.8954 3 12V13H10V12C10 10.8954 9.10457 10 8 10ZM5 9C3.34315 9 2 10.3431 2 12V14H11V12C11 10.3431 9.65685 9 8 9H5Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5 7C7.88071 7 9 5.88071 9 4.5C9 3.11929 7.88071 2 6.5 2C5.11929 2 4 3.11929 4 4.5C4 5.88071 5.11929 7 6.5 7ZM6.5 8C8.433 8 10 6.433 10 4.5C10 2.567 8.433 1 6.5 1C4.567 1 3 2.567 3 4.5C3 6.433 4.567 8 6.5 8Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 7V5H13V7H15V8H13V10H12V8H10V7H12Z"
    />
  </>
);

const Delete = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 3H6V4H10V3ZM11 4V3V2H10H6H5V3V4H4H2V5L3 5V13C3 13.5523 3.44772 14 4 14H12C12.5523 14 13 13.5523 13 13V5H14V4H12H11ZM12 5H11H10H6H5H4V13H12V5ZM6 7H7V11H6V7ZM10 7H9V11H10V7Z"
    />
  </>
);

const Bug = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.12336 10.9724C4.27259 11.2048 4.20521 11.5141 3.97286 11.6633C2.423 12.6587 1.5 14.1163 1.5 15.5C1.5 15.7762 1.27614 16 1 16C0.723858 16 0.5 15.7762 0.5 15.5C0.5 13.675 1.69284 11.9392 3.43246 10.8219C3.66481 10.6727 3.97414 10.7401 4.12336 10.9724ZM12.0885 11.0936C12.2453 10.8663 12.5567 10.8092 12.784 10.966C14.4033 12.0833 15.5 13.7508 15.5 15.5C15.5 15.7762 15.2761 16 15 16C14.7239 16 14.5 15.7762 14.5 15.5C14.5 14.1743 13.6536 12.781 12.216 11.7891C11.9888 11.6323 11.9316 11.3209 12.0885 11.0936Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 12C11.5518 12 14 9.77405 14 7.5C14 5.22595 11.5518 3 8 3C4.4482 3 2 5.22595 2 7.5C2 9.77405 4.4482 12 8 12ZM8 13C11.866 13 15 10.5376 15 7.5C15 4.46243 11.866 2 8 2C4.13401 2 1 4.46243 1 7.5C1 10.5376 4.13401 13 8 13Z"
    />
    <path d="M6.09327 6.50001C6.09327 6.82773 5.8276 7.0934 5.49988 7.0934C5.17216 7.0934 4.90649 6.82773 4.90649 6.50001C4.90649 6.17229 5.17216 5.90662 5.49988 5.90662C5.8276 5.90662 6.09327 6.17229 6.09327 6.50001Z" />
    <path d="M3.29266 1.28598C3.29266 1.77528 2.89601 2.17193 2.40671 2.17193C1.91741 2.17193 1.52075 1.77528 1.52075 1.28598C1.52075 0.79668 1.91741 0.400024 2.40671 0.400024C2.89601 0.400024 3.29266 0.79668 3.29266 1.28598Z" />
    <path d="M14.1555 1.28598C14.1555 1.77528 13.7588 2.17193 13.2695 2.17193C12.7802 2.17193 12.3835 1.77528 12.3835 1.28598C12.3835 0.79668 12.7802 0.400024 13.2695 0.400024C13.7588 0.400024 14.1555 0.79668 14.1555 1.28598Z" />
    <path d="M11.0933 6.50001C11.0933 6.82773 10.8276 7.09341 10.4999 7.09341C10.1722 7.09341 9.90649 6.82773 9.90649 6.50001C9.90649 6.17229 10.1722 5.90662 10.4999 5.90662C10.8276 5.90662 11.0933 6.17229 11.0933 6.50001Z" />
    <path
      opacity="0.5"
      d="M5 7.625C5 7.97018 4.55228 8.25 4 8.25C3.44772 8.25 3 7.97018 3 7.625C3 7.27982 3.44772 7 4 7C4.55228 7 5 7.27982 5 7.625Z"
    />
    <path
      opacity="0.5"
      d="M13 7.625C13 7.97018 12.5523 8.25 12 8.25C11.4477 8.25 11 7.97018 11 7.625C11 7.27982 11.4477 7 12 7C12.5523 7 13 7.27982 13 7.625Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.70003 7.60003C5.92094 7.43434 6.23434 7.47912 6.40003 7.70003C7.20003 8.7667 8.80003 8.7667 9.60003 7.70003C9.76571 7.47912 10.0791 7.43434 10.3 7.60003C10.5209 7.76571 10.5657 8.07912 10.4 8.30003C9.20003 9.90003 6.80003 9.90003 5.60003 8.30003C5.43434 8.07912 5.47912 7.76571 5.70003 7.60003Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.70679 3.52678C4.43064 3.52678 4.20679 3.30292 4.20679 3.02678C4.20679 2.7627 4.06971 2.45678 3.81987 2.20693C3.57002 1.95709 3.2641 1.82001 3.00002 1.82001C2.72388 1.82001 2.50002 1.59616 2.50002 1.32001C2.50002 1.04387 2.72388 0.820014 3.00002 0.820014C3.58933 0.820014 4.13678 1.10963 4.52698 1.49982C4.91717 1.89002 5.20679 2.43747 5.20679 3.02678C5.20679 3.30292 4.98293 3.52678 4.70679 3.52678Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3201 3.52678C11.5962 3.52678 11.8201 3.30292 11.8201 3.02678C11.8201 2.7627 11.9571 2.45678 12.207 2.20693C12.4568 1.95709 12.7628 1.82001 13.0268 1.82001C13.303 1.82001 13.5268 1.59616 13.5268 1.32001C13.5268 1.04387 13.303 0.820014 13.0268 0.820014C12.4375 0.820014 11.8901 1.10963 11.4999 1.49982C11.1097 1.89002 10.8201 2.43747 10.8201 3.02678C10.8201 3.30292 11.0439 3.52678 11.3201 3.52678Z"
    />
  </>
);

const Pause = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M5.5 4C5.22386 4 5 4.22386 5 4.5V11.5C5 11.7761 5.22386 12 5.5 12H6.5C6.77614 12 7 11.7761 7 11.5V4.5C7 4.22386 6.77614 4 6.5 4H5.5ZM9.5 4C9.22386 4 9 4.22386 9 4.5V11.5C9 11.7761 9.22386 12 9.5 12H10.5C10.7761 12 11 11.7761 11 11.5V4.5C11 4.22386 10.7761 4 10.5 4H9.5Z"
  />
);

const Next = () => (
  <>
    <path d="M10.25 7.56699C10.5833 7.75944 10.5833 8.24056 10.25 8.43301L5.75 11.0311C5.41667 11.2235 5 10.983 5 10.5981L5 5.40192C5 5.01702 5.41667 4.77646 5.75 4.96891L10.25 7.56699Z" />
    <rect x="12" y="4" width="1" height="8" rx="0.5" />
  </>
);

const Previous = () => (
  <>
    <path d="M5.75 8.43301C5.41667 8.24056 5.41667 7.75944 5.75 7.56699L10.25 4.96891C10.5833 4.77646 11 5.01702 11 5.40192L11 10.5981C11 10.983 10.5833 11.2235 10.25 11.0311L5.75 8.43301Z" />
    <rect
      x="4"
      y="12"
      width="1"
      height="8"
      rx="0.5"
      transform="rotate(-180 4 12)"
    />
  </>
);

const Play = () => (
  <path d="M11.25 7.56699C11.5833 7.75944 11.5833 8.24056 11.25 8.43301L6.75 11.0311C6.41667 11.2235 6 10.983 6 10.5981L6 5.40192C6 5.01702 6.41667 4.77646 6.75 4.96891L11.25 7.56699Z" />
);

export const iconIndex = {
  Visible,
  Hidden,
  Info,
  Locked,
  Unlocked,
  ArrowRefresh,
  ArrowExternal,
  Swap,
  Checkmark,
  CheckmarkBold,
  Minus,
  X,
  XSmall,
  Plus,
  PlusSmall,
  ExclaimationMark,
  ExclaimationMarkBold,
  Bullet,
  LargeBullet,
  Circle,
  ArrowEast,
  ArrowSouth,
  ArrowWest,
  ArrowNorth,
  ArrowNorthEast,
  ArrowSouthEast,
  ArrowSouthWest,
  ArrowNorthWest,
  ArrowExpand,
  WestCarat,
  EastCarat,
  Upload,
  Download,
  LogOut,
  LogIn,
  Ellipsis,
  Menu,
  Search,
  ChevronDouble,
  ChevronDoubleSmall,
  ChevronNorth,
  ChevronSouth,
  ChevronWest,
  ChevronEast,
  Adjust,
  Gear,
  TriangleEast,
  TriangleSouth,
  TriangleWest,
  TriangleNorth,
  Bitcoin,
  Weather,
  Clock,
  Chat,
  Publish,
  Note,
  Collection,
  Attachment,
  CreateGroup,
  Dojo,
  Notifications,
  Dashboard,
  LeapArrow,
  Messages,
  Tutorial,
  Groups,
  Home,
  Copy,
  AddFile,
  Keyfile,
  Image,
  Users,
  AddUser,
  User,
  Smiley,
  Blank,
  Server,
  Public,
  BootNode,
  Node,
  NullIcon,
  Bug,
  Delete,
  Pause,
  Next,
  Previous,
  Play,
};
